import React from "react"
import styled from "styled-components"
import { up } from "styled-breakpoints"
import Observer from "react-intersection-observer"
import AspectRatio from "../../../../atomic/molecules/AspectRatio"
import { COLORS, TYPE } from "../../../../../theme/styles/globals"

export default class Browser extends React.Component {

  render() {
    return (
        <Container>
            <InView
                tag="div"
                onChange={inView => 
                    inView
                        ? document.getElementById(`video-${this.props.uid}`).play()
                        : document.getElementById(`video-${this.props.uid}`).pause()
                }
                rootMargin={"0px 200px"}
            >
                <AspectRatio align={"MIDDLE"} ratio={"26:14"} max={"0.6"}>
                    <VideoWrap>
                        <LabelWrap>
                            <Label color={this.props.mode === "LIGHT" ? `${COLORS.BLACK}` : `${COLORS.WHITE}`}>{this.props.label}</Label>
                        </LabelWrap>
                        <Video 
                            id={`video-${this.props.uid}`}
                            loop 
                            muted 
                            playsInline
                        >
                            <source src={this.props.url} type="video/mp4" />
                        </Video>
                    </VideoWrap>
                    <SVG viewBox="0 0 1657.2 1015.2">
                        <path
                            d="M1644 0c7.2 0 13 5.8 13 13v1002H0V13C0 5.8 5.8 0 13 0h1631zm12 84H1v930h1655V84zm-11.7-83H13C6.5 1 1.2 6.2 1 12.7V83h1655V13c0-6.5-5.2-11.8-11.7-12zM57.5 32.5c5.5 0 10 4.5 10 10s-4.5 10-10 10-10-4.5-10-10 4.5-10 10-10zm39 0c5.5 0 10 4.5 10 10s-4.5 10-10 10-10-4.5-10-10 4.5-10 10-10zm39 0c5.5 0 10 4.5 10 10s-4.5 10-10 10-10-4.5-10-10 4.5-10 10-10zm-78 1c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm39 0c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm39 0c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9z"
                            fill={this.props.mode === "LIGHT" ? `${COLORS.BLACK}` : `${COLORS.WHITE}`}
                        />
                    </SVG>
                </AspectRatio>
            </InView>
        </Container>
    )
  }

}

const InView = styled(Observer)`
  width: 100%;
  height: 100%;
  position: relative;
  display:flex;
`

const Container = styled.div`
    position:relative;
    padding-left:16px;
    padding-right:16px;
    margin-bottom:30px;

    ${up("md")} {
        display:flex;
        margin-top:-8vh;
        padding-left:0px;
        padding-right:0px;
        margin-bottom:0px;
    }
`

const SVG = styled.svg`
    position: absolute;
    top: -17px;

    ${up("md")} {
        position: relative;
        top:auto;
    }
`

const VideoWrap = styled.div`
    
    ${up("md")} {
        width:100%;
        position:absolute;
        left:0px;
        bottom:-8.1vh;
    }
`

const Video = styled.video`
    width:100%;
`

const LabelWrap = styled.div`
  transform: rotate(90deg);
  transform-origin: 0 0;
  position: absolute;
  display:none;
  line-height: 0px;

  ${up("md")} {
    display: table;
    left: -2%;
    top: 0;
  }
`

const Label = styled.p`
  font-family: ${TYPE.MONO_FONT};
  font-size: 1.1vh;
  color: ${props => props.color};
  line-height: 0px;
  opacity:.7;
  text-transform:uppercase;
`